/**
 * 枚举
 */

export const loginType = {
    ACCOUNT: 1,
    SMS_CODE: 2,
};

export const terminal = 4